export const userRoles = [
  { label: "Consejero local", value: "LOCAL_COUNCIL" },
  { label: "Consejero directivo", value: "DIRECTIVE_COUNCIL" },
  { label: "Comité técnico", value: "TECHNICAL_COMMITTEE" },
  { label: "Administrador", value: "ADMIN" },
  { label: "Administrador asistente", value: "ADMIN_ASSISTANT" },
  { label: "Administrador auxiliar", value: "ADMIN_BASIC" },
  { label: "Administrador Pagos" , value: "ADMIN_PAYMENTS" },
  { label: "Administrador tecnico y financiero", value:  "ADMIN_TECHNICAL_AND_FINANCIAL"},
  { label: "Implementadora", value: "IMPLEMENTER" },
  {label: "Administrador evaluador", value: "ADMIN_EVALUATOR"}
]
